export default "__VITE_ASSET__g6RVbrjG__"